'use client'

import type { Course } from '@/payload-types'

import { useLivePreview } from '@payloadcms/live-preview-react'

import { CourseChapterPageContent } from './CourseChapterPageContent'
import { getServerSideURL } from '@/utilities/getURL'

type Props = {
  activeChapterSlug: string
  initialCourse: Course
}

export const CourseChapterPreview = ({ activeChapterSlug, initialCourse }: Props) => {
  const { data } = useLivePreview<Course>({
    depth: 2,
    initialData: initialCourse,
    serverURL: getServerSideURL(),
  })

  if (!data) return null

  return <CourseChapterPageContent activeChapterSlug={activeChapterSlug} course={data} hasPurchased />
}